/* KIRIBAN welcome cards: pins the card table and deals the four cards as the visitor scrolls.
   Each card owns 20% of the scroll: dealt from the deck and flipped, held face-on beside its explanation,
   then laid aside. From 90% the four cards fan out. The card in front tilts with the mouse; on touch screens
   its foil drifts by itself.
   Performance: no layout is read while scrolling (positions are measured once, and again on resize); the
   progress is eased towards the scroll position so movement stays smooth on phones; only the card in front
   gets per-frame foil updates; the loop runs only while the section is on screen and stops when idle. */
(function () {
  "use strict";
  var root = document.querySelector("[data-kbc]");
  if (!root) return;
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;   // stays a simple grid

  var track = root.querySelector("[data-kbc-track]");
  var pin = root.querySelector("[data-kbc-pin]");
  var intro = root.querySelector("[data-kbc-intro]");
  var els = Array.prototype.slice.call(root.querySelectorAll("[data-kbc-card]"));
  var copies = Array.prototype.slice.call(root.querySelectorAll(".kbc-copy"));
  var prog = root.querySelectorAll(".kbc-progress span");
  var N = els.length;
  if (!N) return;
  root.classList.add("is-live", "is-start");
  var touchUI = matchMedia("(hover: none)").matches; if (touchUI) root.classList.add("is-touch");

  var SEG = 0.8 / N, START = 0.10, FAN = 0.90;
  var touch = matchMedia("(hover: none)").matches;
  function ease(t) { t = t < 0 ? 0 : t > 1 ? 1 : t; return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function mix(A, B, t) { return { x: lerp(A.x, B.x, t), y: lerp(A.y, B.y, t), s: lerp(A.s, B.s, t), ry: lerp(A.ry, B.ry, t), rz: lerp(A.rz, B.rz, t), z: lerp(A.z, B.z, t) }; }

  /* ---------- geometry, measured once per resize ---------- */
  var G = {}, L = {};
  function measure() {
    var hd = parseFloat(getComputedStyle(pin).top) || 0;
    var w = pin.clientWidth, h = pin.clientHeight, mob = w < 820;
    var cw, ct, cxD = 0, rowC = 0, fanC = 0;
    if (mob) {
      var it = 16, ih = intro.offsetHeight;
      var th = 0; copies.forEach(function (c) { th = Math.max(th, c.offsetHeight); });
      var gapA = 16, gapB = 16, gapC = 18, foot = 18;
      var room = h - it - ih - gapA - gapB - th - gapC - 2 - foot;
      cw = Math.max(150, Math.min(w * .72, room / 1.5));
      var used = it + ih + gapA + cw * 1.5 + gapB + th + gapC + 2;
      var slack = Math.max(0, (h - foot - used) / 2);
      it += slack * .6;                                  // keep the group visually centred, a little high
      ct = it + ih + gapA;
      var pt = ct + cw * 1.5 + gapB;
      pin.style.setProperty("--it", it.toFixed(1) + "px");
      pin.style.setProperty("--pt", pt.toFixed(1) + "px");
      pin.style.setProperty("--gt", (pt + th + gapC).toFixed(1) + "px");
      pin.style.setProperty("--gy", (ct + cw * .75).toFixed(1) + "px");
    } else {
      // desktop: card and text sit side by side as one centred group; finished cards pile up on the far left
      cw = Math.min(h * .56, w * .40, 500);
      ct = (h - cw * 1.5) / 2;
      var gap = Math.max(48, Math.min(96, w * .05)), pw = Math.min(440, w * .36);
      var sx = Math.max(w * .14, (w - (cw + gap + pw)) / 2), pl = sx + cw + gap;
      cxD = sx + cw / 2;
      rowC = Math.max(cw * .15 + 10, Math.min(w * .08, sx - 20 - cw * .15));
      var fanHalf = cw * .77;
      fanC = Math.max(fanHalf + 12, Math.min(cxD, (pl - 24) / 2));
      pin.style.removeProperty("--it"); pin.style.removeProperty("--pt"); pin.style.removeProperty("--gt");
      pin.style.setProperty("--gy", (h / 2).toFixed(1) + "px");
      pin.style.setProperty("--pl", pl.toFixed(1) + "px");
      pin.style.setProperty("--pw", pw.toFixed(1) + "px");
    }
    pin.style.setProperty("--cw", cw.toFixed(1) + "px");
    var ch = cw * 1.5, cx = mob ? w * .5 : cxD;
    pin.style.setProperty("--gx", cx.toFixed(1) + "px");
    L = {
      mob: mob, cw: cw, ch: ch,
      deck: { x: cx - cw / 2, y: ct + (mob ? 10 : 24), s: .9 },
      hero: { x: cx - cw / 2, y: ct, s: 1 },
      row: function (i) { return mob ? { x: cx - cw / 2 + (i - 1) * cw * .05 - cw * .04, y: ct + i * 3, s: .96 }
                                     : { x: rowC - cw / 2, y: h * .5 - ch / 2 + (i - 1) * ch * .33, s: .3 }; },
      fan: function (i) { var fx = mob ? w * .5 - cw * .05 : fanC;
        return { x: fx - cw / 2 + (i - (N - 1) / 2) * cw * (mob ? .16 : .3), y: mob ? ct + ch * .08 : h * .5 - ch / 2, s: mob ? .7 : .64 }; }
    };
    var r = track.getBoundingClientRect();
    G = { top: r.top + window.scrollY - hd, total: Math.max(1, track.offsetHeight - pin.offsetHeight) };
    last = []; // force every card to be redrawn
  }

  function target() { var p = (window.scrollY - G.top) / G.total; return p < 0 ? 0 : p > 1 ? 1 : p; }

  function pose(i, p) {
    var D = L.deck, H = L.hero, R = L.row(i), F = L.fan(i);
    var deckP = { x: D.x - i * 2, y: D.y - i * 2, s: D.s, ry: 180, rz: -6 + i * 3.2, z: 10 - i };
    var heroP = { x: H.x, y: H.y, s: 1, ry: 0, rz: 0, z: 40 };
    var rowP = { x: R.x, y: R.y, s: R.s, ry: 0, rz: -8 + i * 5, z: 20 + i };
    var fanP = { x: F.x, y: F.y, s: F.s, ry: 0, rz: (i - (N - 1) / 2) * 7, z: 30 + i };
    var s0 = START + i * SEG, s1 = s0 + SEG, end = i === N - 1, a;
    if (p < s0) a = deckP;
    else if (p < s0 + .07) { var t = ease((p - s0) / .07); a = mix(deckP, heroP, t); a.y -= Math.sin(t * Math.PI) * L.ch * .16; }
    else if (p < s1 - .04 || (end && p < FAN)) a = heroP;
    else if (!end && p < s1) a = mix(heroP, rowP, ease((p - (s1 - .04)) / .04));
    else if (p < FAN) a = rowP;
    else a = mix(end ? heroP : rowP, fanP, ease((p - FAN) / .08));
    return a;
  }

  /* ---------- state ---------- */
  var P = 0, cur = -2, heroIdx = -1, last = [], tilt = { x: 0, y: 0, tx: 0, ty: 0, on: false };
  var live = false, raf = 0, idle = 0, moving0 = false, mvT = 0;

  function setActive(active) {
    if (active === cur) return;
    var prev = cur; cur = active;
    copies.forEach(function (c, i) { c.classList.toggle("on", i === active); });
    for (var j = 0; j < prog.length; j++) prog[j].classList.toggle("on", active >= 0 && j <= Math.min(active, N - 1));
    if (active >= 0 && active < N && active > prev) {          // a card has just been turned face up
      var el = els[active]; el.classList.remove("is-flash");
      setTimeout(function () { el.classList.add("is-flash"); }, 320);
    }
  }

  function foil(el, px, py, g) {
    el.style.setProperty("--px", px.toFixed(3)); el.style.setProperty("--py", py.toFixed(3));
    el.style.setProperty("--mx", (px * 100).toFixed(1) + "%"); el.style.setProperty("--my", (py * 100).toFixed(1) + "%");
    el.style.setProperty("--glare", g);
  }

  function frame(now) {
    raf = 0;
    var T = target(), d = T - P;
    P = Math.abs(d) < .0004 ? T : P + d * (touch ? .22 : .16);
    root.classList.toggle("is-start", P < .035);
    var mv = Math.abs(d) > .0015; if (mv !== moving0) { moving0 = mv; if (mv) { clearTimeout(mvT); root.classList.add("is-moving"); } else { mvT = setTimeout(function () { root.classList.remove("is-moving"); }, 140); } }
    var active = P < START ? -1 : Math.min(N - 1, Math.floor((P - START) / SEG));
    if (P >= FAN) active = N;
    setActive(active);

    if (!tilt.on) { tilt.tx = 0; tilt.ty = 0; }
    tilt.x += (tilt.tx - tilt.x) * .14; tilt.y += (tilt.ty - tilt.y) * .14;

    var newHero = -1;
    for (var i = 0; i < N; i++) {
      var el = els[i], a = pose(i, P), hero = i === active && Math.abs(a.ry) < 1 && a.s > .98;
      if (hero) newHero = i;
      var tx = hero ? tilt.x : 0, ty = hero ? tilt.y : 0;
      var tf = "translate3d(" + a.x.toFixed(1) + "px," + a.y.toFixed(1) + "px,0) scale(" + a.s.toFixed(3) + ") rotateZ(" + a.rz.toFixed(2) +
        "deg) rotateY(" + (a.ry + tx).toFixed(2) + "deg) rotateX(" + (-ty).toFixed(2) + "deg)";
      var z = String(Math.round(a.z));
      if (!last[i] || last[i].tf !== tf) { el.style.transform = tf; (last[i] = last[i] || {}).tf = tf; }
      if (last[i].z !== z) { el.style.zIndex = z; last[i].z = z; }
    }
    if (newHero !== heroIdx) {
      if (heroIdx >= 0) { els[heroIdx].classList.remove("is-hero"); foil(els[heroIdx], .5, .5, "0"); }
      if (newHero >= 0) els[newHero].classList.add("is-hero");
      heroIdx = newHero;
    }
    if (heroIdx >= 0) {                                          // foil only on the card in front
      var px, py;
      if (tilt.on) { px = .5 + tilt.x / 20; py = .5 + tilt.y / 20; }
      else { var sw = (now / 5600) % 1; px = .14 + sw * .72; py = .5 + Math.sin(sw * Math.PI * 2) * .18; }
      foil(els[heroIdx], px, py, tilt.on || touch ? "1" : ".7");
    }

    // keep running while moving, while a card is in front (its foil drifts), or while the pointer tilts it
    var moving = Math.abs(T - P) > .0004 || Math.abs(tilt.x - tilt.tx) > .01 || Math.abs(tilt.y - tilt.ty) > .01;
    if (moving || heroIdx >= 0) idle = 0; else idle++;
    if (live && idle < 2) raf = requestAnimationFrame(frame);
  }
  function kick() { idle = 0; if (live && !raf) raf = requestAnimationFrame(frame); }

  /* ---------- controlled stepping ----------
     Inside the pinned section, one wheel gesture or one swipe moves exactly one stop (deck, card 1–4, fan), so a hard
     scroll can never skip a card. At the first stop (scrolling up) and the last stop (scrolling down) the page scrolls
     normally, so visitors can always leave the section. After any other scroll (scrollbar, keys, momentum from outside),
     the stage settles on the nearest stop. */
  var STOPS = [0];
  for (var k = 0; k < N; k++) STOPS.push(START + k * SEG + (.07 + SEG - .04) / 2);
  STOPS.push(.99);
  var EPS = .004, anim = null, lastStep = 0, lastWheel = 0;
  function pNow() { return (window.scrollY - G.top) / G.total; }
  // content above the section (film, fonts, banners) can change height after load, so the section's position is re-read
  // whenever a gesture starts rather than trusted from the last measure
  function syncTop() { var r = track.getBoundingClientRect(); G.top = r.top + window.scrollY - (parseFloat(getComputedStyle(pin).top) || 0); }
  function pinned() { var y = window.scrollY; return y >= G.top - 2 && y <= G.top + G.total + 2; }
  function nextStop(dir) {
    var p = pNow(), i;
    if (dir > 0) { for (i = 0; i < STOPS.length; i++) if (STOPS[i] > p + EPS) return STOPS[i]; }
    else { for (i = STOPS.length - 1; i >= 0; i--) if (STOPS[i] < p - EPS) return STOPS[i]; }
    return null;
  }
  function atEdge(dir) { var p = pNow(); return (dir < 0 && p <= STOPS[0] + EPS) || (dir > 0 && p >= STOPS[STOPS.length - 1] - EPS); }
  function glide(p, ms) {
    var y0 = window.scrollY, y1 = G.top + p * G.total, t0 = performance.now();
    if (anim) cancelAnimationFrame(anim.raf);
    anim = { raf: 0 };
    (function tick(now) {
      var t = Math.min(1, (now - t0) / ms), e = t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      window.scrollTo({ top: y0 + (y1 - y0) * e, behavior: "instant" });   // the site sets scroll-behavior:smooth; the glide must not be smoothed twice
      if (t < 1) anim.raf = requestAnimationFrame(tick); else anim = null;
    })(t0);
    lastStep = performance.now();
  }
  function step(dir) { var to = nextStop(dir); if (to === null) return false; glide(to, 720); return true; }

  var wheelLock = false;                                      // true from a step until the wheel/trackpad goes quiet
  addEventListener("wheel", function (e) {
    if (e.ctrlKey || Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
    if (!anim) syncTop();
    if (!pinned()) return;
    // event.timeStamp is when the event happened, so a busy main thread can't fake a pause between two events of one gesture
    var dir = e.deltaY > 0 ? 1 : -1, now = e.timeStamp || performance.now(), quiet = now - lastWheel > 300;
    lastWheel = now;
    if (quiet) wheelLock = false;
    if (atEdge(dir) && !anim && !wheelLock) return;           // let the page scroll out of the section
    e.preventDefault();
    if (anim || wheelLock || Math.abs(e.deltaY) < 3) return;
    if (step(dir)) wheelLock = true;                          // one step per gesture: inertia can't skip a card
  }, { passive: false });

  var ty0 = 0, tDir = 0, tDone = false, tOn = false;
  addEventListener("touchstart", function (e) {
    if (e.touches.length !== 1) { tOn = false; return; }
    if (!anim) syncTop();
    tOn = pinned(); ty0 = e.touches[0].clientY; tDir = 0; tDone = false;
  }, { passive: true });
  addEventListener("touchmove", function (e) {
    if (!tOn || e.touches.length !== 1) return;
    var dy = ty0 - e.touches[0].clientY;
    if (!tDir) { if (Math.abs(dy) < 6) return; tDir = dy > 0 ? 1 : -1; if (atEdge(tDir) && !anim) { tOn = false; return; } }
    if (e.cancelable) e.preventDefault();
    if (!tDone && !anim && Math.abs(dy) > 28) { tDone = step(tDir) || true; }
  }, { passive: false });

  var settleT = 0;
  addEventListener("scroll", function () {
    clearTimeout(settleT);
    settleT = setTimeout(function () {
      if (anim || !pinned()) return;
      var p = pNow(), best = STOPS[0];
      if (p <= EPS || p >= STOPS[STOPS.length - 1] - EPS) return;
      STOPS.forEach(function (s) { if (Math.abs(s - p) < Math.abs(best - p)) best = s; });
      if (Math.abs(best - p) > EPS) glide(best, 420);
    }, 160);
  }, { passive: true });

  pin.addEventListener("pointermove", function (e) {
    if (e.pointerType !== "mouse" || heroIdx < 0) return;
    var r = els[heroIdx].getBoundingClientRect(), nx = (e.clientX - r.left) / r.width - .5, ny = (e.clientY - r.top) / r.height - .5;
    if (nx < -.5 || nx > .5 || ny < -.5 || ny > .5) { tilt.on = false; kick(); return; }
    tilt.tx = nx * 16; tilt.ty = ny * 16; tilt.on = true; kick();
  });
  pin.addEventListener("pointerleave", function () { tilt.on = false; kick(); });
  addEventListener("scroll", kick, { passive: true });

  var rt = 0;
  function onResize() { clearTimeout(rt); rt = setTimeout(function () { measure(); kick(); }, 120); }
  addEventListener("resize", onResize);
  if ("ResizeObserver" in window) new ResizeObserver(onResize).observe(document.body);
  addEventListener("load", function () { measure(); kick(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); kick(); });

  measure(); P = target(); frame(performance.now());
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      live = en[0].isIntersecting;
      if (live) kick(); else if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }, { rootMargin: "200px 0px" }).observe(track);
    // load every card's art once the section is close, so no card flips to a blank face
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      root.querySelectorAll(".kbc-art img").forEach(function (im) { im.loading = "eager"; });
      io.disconnect();
    }, { rootMargin: "1200px 0px" });
    io.observe(root);
  } else { live = true; kick(); }
})();
